export default "__VITE_ASSET__Bv7vRGMR__"